import React, { useEffect, useState } from "react";
import { PageHeader, StatusBadge, EmptyState } from "@/components/Layout";
import api from "@/lib/api";

export default function Archive() {
  const [campaigns, setCampaigns] = useState([]);
  const [selected, setSelected] = useState(null);
  const [plans, setPlans] = useState([]);

  useEffect(() => { api.get("/planco/archive/campaigns").then(r=>setCampaigns(r.data)); }, []);
  const open = async (c) => {
    setSelected(c);
    const r = await api.get(`/planco/archive/campaigns/${c.id}/plans`); setPlans(r.data);
  };

  return (
    <>
      <PageHeader title="Arhivă Programări" subtitle={`${campaigns.length} campanii istorice`} />
      {!selected ? (
        <div style={{display:"grid",gap:12}}>
          {campaigns.map(c => (
            <div key={c.id} className="card fade-up" style={{padding:20,cursor:"pointer"}} onClick={()=>open(c)} data-testid={`archive-camp-${c.planning_year}`}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12}}>
                <div>
                  <div style={{display:"flex",gap:10,alignItems:"center"}}>
                    <span style={{fontSize:11,color:"var(--blue-primary)",fontWeight:700,letterSpacing:"0.05em",textTransform:"uppercase"}}>An {c.planning_year}</span>
                    <StatusBadge status={c.status} />
                  </div>
                  <div style={{fontSize:17,fontWeight:700,color:"var(--navy)",marginTop:4}}>{c.name}</div>
                  <div style={{fontSize:12,color:"#64748B",marginTop:4}}>Valabilitate programare: {c.access_start} → {c.access_end}</div>
                </div>
                <button className="btn btn-secondary">Deschide →</button>
              </div>
            </div>
          ))}
          {campaigns.length===0 && <EmptyState text="Nicio campanie arhivată încă." />}
        </div>
      ) : (
        <>
          <div style={{marginBottom:14}}>
            <button className="btn btn-secondary" onClick={()=>{setSelected(null);setPlans([]);}}>← Înapoi la campanii</button>
          </div>
          <div className="card" style={{padding:20,marginBottom:14}}>
            <div style={{fontSize:11,color:"var(--blue-primary)",fontWeight:700,textTransform:"uppercase",letterSpacing:"0.05em"}}>Campanie arhivată · An {selected.planning_year}</div>
            <div style={{fontSize:18,fontWeight:700,color:"var(--navy)"}}>{selected.name}</div>
          </div>
          <div className="card">
            <table className="tbl">
              <thead><tr><th>Marcă</th><th>Angajat</th><th>Structură</th><th>Status</th><th className="tabular-nums">Zile</th><th>Perioade</th></tr></thead>
              <tbody>{plans.map(p=>(
                <tr key={p.id}>
                  <td className="tabular-nums" style={{fontWeight:600}}>{p.marca}</td>
                  <td>{p.person_name}</td>
                  <td>{p.org_unit_name}</td>
                  <td><StatusBadge status={p.status} /></td>
                  <td className="tabular-nums">{p.total_days}</td>
                  <td style={{fontSize:12,color:"#64748B"}}>{p.periods.map(pp=>`${pp.start_date}→${pp.end_date} (${pp.days}z)`).join(" · ")}</td>
                </tr>
              ))}</tbody>
            </table>
            {plans.length===0 && <EmptyState text="Nicio programare în această campanie." />}
          </div>
        </>
      )}
    </>
  );
}
